import { IconButton, IconButtonProps, Tooltip } from "@mui/material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import React from "react";
import { useIntl } from "react-intl";

const CloneIconButton = (props: IconButtonProps) => {
  const { formatMessage: t } = useIntl();
  return (
    <Tooltip title={t({ id: "cloneLabel" })}>
      <IconButton {...props}>
        <FileCopyIcon />
      </IconButton>
    </Tooltip>
  );
};

export default CloneIconButton;
